import styled from 'styled-components'
import { CurrencyInput } from '@navent-jobs/ui-kit/components/input'
import { Button } from '@navent-jobs/ui-kit/components/button'
import { Link } from '@navent-jobs/ui-kit/components/link'

export const InputSalario = styled<{ salarioRequeridoError: boolean }>(CurrencyInput)`
  width: 100%;
  * {
    text-overflow: ellipsis;
  }
`

export const ButtonPostularme = styled(Button)`
  margin-top: 10px;
  ${({ productoLookAndFeel }) =>
    productoLookAndFeel
      ? `background-color: ${productoLookAndFeel?.colorBackgroundBotones} !important;
      border-color:${productoLookAndFeel?.colorBordeCaja} !important;`
      : ``}

  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    margin-top: ${({ isPinned }) => (isPinned ? '10px' : '0')};
  }

  @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    margin-top: ${({ isPinned }) => (isPinned ? '0' : '10px')};
  }

  @media (min-width: 1024px) {
    margin-top: 0;
  }
`

export const HelperTextSalario = styled('div')`
  margin-top: 4px;
`

export const MessaggeError = styled.div`
  display: flex;
  padding-top: 4px;
  color: ${({ theme }) => theme.colors.danger.normal};
`

export const LinkCustom = styled(Link)`
  text-decoration: underline;
  font-size: 12px;
  line-height: 16px;
  padding: 0;
  display: initial;
  margin: 0;
`

export const Spacer = styled.div`
  padding: 6px 0px;
`

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-self: center;
  gap: 8px;
`
